<template>
    <div class="games-promotions page">
        <b-container>
            <b-row class="games-promotions__content" v-if="promotions.length > 0">
                <b-col cols="12" sm="6" v-for="promo in promotions" :key="promo.id" class="games-promotions-item-wrap">                                        
                    <PromoGamesCard :promoGame="promo" v-inview="'fade-up'" :type="'promotion'"/>
                </b-col>
            </b-row>
            <b-row v-else class="games-promotions__content">
                <b-col cols="12" class="d-flex justify-content-center align-items-center">
                    Átmenetileg kifogytunk a promóciókból, gyere vissza később!
                </b-col>
            </b-row>
        </b-container>
        <PageLoading  /> 
    </div>
</template>

<script>
import apiH from '@/mixins/apiHandlerMI.js'
import PromoGamesCard from '@/components/pages/promoGames/PromoGamesCard.vue'
import PageLoading from '@/components/layout/PageLoading.vue'

export default {
    mixins: [apiH],
    components:{
        PromoGamesCard,
        PageLoading
    },
    data(){
        return{
            promotions: []
        }
    },
    created(){
        this.getPromotions()
    },
    mounted(){
        this.setMetaTags({
            title: 'Soproni - Promóciók', 
            desc: null, 
            keywords: null, 
            ogType: 'website', 
            ogTitle: 'Soproni - Promóciók',                         
            ogImage: null, 
            ogImageWidth: null, 
            ogImageHeight: null, 
            ogDesc:null
        })
    },
    methods:{
        getPromotions(){
            let _this = this

            _this.get('promotion',
                {
                    params: {                          
                        relations:1,                                       
                        where: [
                            ['where','status', '1'],                                                
                        ],
                        order_by:[['sort_order', 'asc'], ['published_date', 'desc']]
                    }
                },
                function(resp){                                        
                    _this.promotions = resp.data.promotion                    
                    
                }, function(err){
                    console.log(err);
                    _this.promotions = []
                }
            )
        }
    }
}
</script>